import axios from "axios";

export const SET_BANNERS = "SET_BANNERS";
export const BANNER_ERROR = "BANNER_ERROR";
export const CREATE_BANNER = "CREATE_BANNER";
export const DELETE_BANNER = "DELETE_BANNER";

export function fetchBanners() {
  return (dispatch) => {
    axios
      .get(`${process.env.REACT_APP_API_PATH}/banner/images?show_all=true`)
      .then((res) => {
        dispatch({ type: SET_BANNERS, data: res.data.banner_images });
      })
      .catch((err) => {
        dispatch({ type: BANNER_ERROR, data: err.message });
        console.log(err);
      });
  };
}

export function updateBanner(bannerId, updates) {
  return (dispatch) => {
    axios
      .patch(`${process.env.REACT_APP_API_PATH}/banner/${bannerId}`, updates, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("sketch-token")}`,
        },
      })
      .then(() => {
        dispatch(fetchBanners());
      })
      .catch((err) => {
        dispatch({ type: BANNER_ERROR, data: err.message });
        console.log(err);
      });
  };
}

export function createBanner(bannerFile) {
  return () => {
    const request_body = new FormData();
    request_body.append("file", bannerFile);
    request_body.append("priority", "0");

    axios
      .post(`${process.env.REACT_APP_API_PATH}/banner/images`, request_body, {
        headers: {
          Authorization: "bearer " + localStorage.getItem("sketch-token"),
        },
      })
      .then(() => {
        alert("Banner is Successfully uploaded!");
        window.location.reload(false);
      })
      .catch((err) => {
        alert("ERROR: " + err.response.data.detail);
        console.log(err);
      });
  };
}

export function deleteBanner(bannerId) {
  return (dispatch) => {
    axios
      .delete(`${process.env.REACT_APP_API_PATH}/banner/${bannerId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("sketch-token")}`,
        },
      })
      .then(() => {
        dispatch({ type: DELETE_BANNER, data: bannerId });
      })
      .catch((err) => {
        dispatch({ type: BANNER_ERROR, data: err.message });
        console.log(err);
      });
  };
}
